<template>
  <v-navigation-drawer
    v-model="drawer"
    width="100%"
    absolute
    temporary
    class="primary "
    dark
  >
    <div class="user-menu">
      <div class="user-menu-items-container">
        <ul class="user-menu-items">
          <li @click="close"><v-icon x-large>mdi-close</v-icon></li>
          <li @click="editUser = !editUser">
            <v-icon>mdi-account-cog</v-icon> Editar perfil
          </li>
          <li @click="$router.push('/creditos')">
            <v-icon>mdi-credit-card-plus</v-icon> comprar créditos
          </li>
          <li @click="rateProfessor = !rateProfessor">
            <v-icon>mdi-star</v-icon> Avaliar aulas
          </li>
          <li @click="contactOpen = !contactOpen">
            <v-icon>mdi-comment-text</v-icon> Contato
          </li>
          <li @click="$store.dispatch('logout')">
            <v-icon style="margin-top: -4px;">mdi-power</v-icon> desconectar
          </li>
        </ul>
      </div>
    </div>
    <ContactDialog :visibility="contactOpen" @changed="contactOpen = $event" />
    <StudentsProfileDialog
      :visibility="editUser"
      @negative="editUser = !editUser"
      @positive="saveProfile"
      :profile="userProfile"
    />
    <ProfessorRatingDialog
      :visibility="rateProfessor"
      @negative="onStudentRate"
      @positive="onStudentRate"
    />

    <!-- <ProfessorRatingDialog
      :visibility="rateProfessor || showRatingProf"
      @negative="onStudentRate"
      @positive="onStudentRate"
    /> -->
  </v-navigation-drawer>


</template>

<script>
import ProfileServiceMixin from "@/mixins/services/ProfileServiceMixin";
import StudentsProfileDialog from "@/components/dialogs/StudentsProfileDialog";
import ProfessorRatingDialog from "@/components/dialogs/ProfessorRatingDialog";
import ContactDialog from "@/components/dialogs/ContactDialog";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  mixins: [ProfileServiceMixin],
  components: {
    ContactDialog,
    StudentsProfileDialog,
    ProfessorRatingDialog
  },
  props: {
    visibility: Boolean
  },
  data() {
    return {
      editUser: undefined,
      rateProfessor: undefined,
      contactOpen: undefined,
      drawer: undefined,
      showRatingProf: false
    };
  },
  computed: {
    //...mapState(["userProfile", "rating"])
    ...mapState(["userProfile"])
  },

  watch: {
    visibility: {
      immediate: true,
      handler(val) {
        this.drawer = val;
      }
    }
  },

  mounted() {
    setTimeout(() => {
      if (this.rating && this.rating.subject_class) {
        this.showRatingProf = true
      }
    }, 1000);
  },


  methods: {
    onStudentRate() {
      this.rateProfessor = false;
    },
    close() {
      this.drawer = false;
      this.$emit("close", false);
    },
    async saveProfile(form) {
      await this.onStudentEdit(form)
      this.$emit('positive')
    }
  }
};
</script>
<style>
.user-menu {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: rgba(69, 0, 153, 1);
  background-image: url("../../assets/textured-paper.png");
  background-repeat: repeat;
  z-index: 999;
  box-shadow: none;
}
.user-menu-items-container {
  display: flex;
  align-items: center;
  min-height: 85vh;
  position: relative;
}
.user-menu-items {
  display: block;
  width: 100%;
  padding: 90px 0 30px;
  margin: 0 0 60px;
}
.user-menu-items li {
  color: #ffffff;
  display: block;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 1.2;
  padding: 0 0 24px;
  cursor: pointer;
}
.user-menu-items li i {
  color: #ffffff;
}
.user-menu-items li:first-child {
  position: absolute;
  top: 90px;
  right: 0;
  transform: translate(-0%, -100%);
  padding: 21px;
}
.user-menu-items li:last-child {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  font-weight: 400;
  margin-top: 60px;
  color: rgba(255, 255, 255, 0.7);
}
.user-menu-items li:last-child i {
  color: rgba(255, 255, 255, 0.7);
}
.user-menu-items li:hover,
.user-menu-items li:hover i {
  color: rgba(255, 255, 255, 0.8);
}
.user-menu-items li:active,
.user-menu-items li:active i {
  color: #44ff99;
}
</style>
